// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__30GaW","top":"styles_top__9rIKc"};